import React from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { AiOutlineTrophy } from 'react-icons/ai';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow, TableUser, TableUserContent, TableUserTitle } from '@/components/ui/table';
import { IconWrapper } from '@/components/custom/icon';

const TableRegionals = ({ ordenedRegionals, sortDirection, setSortDirection, onSelectRegional }) => {
  return (
    <Table className="min-w-[480px]">
      <TableHeader>
        <TableRow>
          <TableHead
            scope="col"
            className="w-[80px]"
          >
            Posição
          </TableHead>
          <TableHead
            scope="col"
            className="w-[44px]"
          />
          <TableHead scope="col">GRE</TableHead>
          <TableHead
            scope="col"
            className="w-[148px] text-right"
          >
            Pontuação total{' '}
            <IconWrapper
              size="sm"
              className="cursor-pointer"
              onClick={() => setSortDirection(prev => (prev === 'desc' ? 'asc' : 'desc'))}
            >
              {sortDirection === 'desc' ? <FiChevronDown /> : <FiChevronUp />}
            </IconWrapper>
          </TableHead>
        </TableRow>
      </TableHeader>

      <TableBody>
        {ordenedRegionals?.map((item, i) => (
          <TableRow
            className="cursor-pointer"
            onClick={() => onSelectRegional(item)}
            key={item.id}
          >
            <TableHead scope="row">{i + 1}</TableHead>
            <TableCell>
              {sortDirection === 'desc' && i === 0 && (
                <AiOutlineTrophy
                  size={16}
                  className="text-[#FFD661]"
                />
              )}
              {sortDirection === 'desc' && i === 1 && (
                <AiOutlineTrophy
                  size={16}
                  className="text-[#8894AC]"
                />
              )}
              {sortDirection === 'desc' && i === 2 && (
                <AiOutlineTrophy
                  size={16}
                  className="text-[#D3681A]"
                />
              )}
            </TableCell>
            <TableCell>
              <TableUser>
                <TableUserContent>
                  <TableUserTitle>{item.name}</TableUserTitle>
                </TableUserContent>
              </TableUser>
            </TableCell>
            <TableCell className="text-right">{item.score}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export { TableRegionals };
